export const GENERIC_EVENTS = {
  PAGE_VIEW: 'Page View',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  NOTIFICATION_PANEL_OPENED: 'Notification panel opened',
  NOTIFICATION_CLICKED: 'Notification clicked',
  SEARCH: 'Search',
  HELP_CENTER_CLICKED: 'Help Center clicked',
  SUPPORT_CHAT_CLICKED: 'Support Chat clicked',
  SEV_1_ERROR: 'sev1Error',
  // rabbit events
  QUICK_HELP_CLICKED: 'Quick Help Clicked',
  MODULE_PREFERENCE_NAVIGATION: 'Navigated to module preferences',
  CLICKED_ON_PREFERENCES_TAB: 'Clicked on Preferences Tab',
  DOWNLOAD_CSV: 'Download csv',
  EXPANDED_CHART: 'Expanded chart',
  CLICKED_ON_MORE_VIEWS: 'Clicked on More Views',
  CLICKED_ON_HELP_ME_WRITE: 'Clicked on Help me write',
  USED_MESH_MAVEN_GENERATED_CONTENT: 'Used Maven generated content',
  REPHRASED_MESH_MAVEN_CONTENT: 'Rephrased Maven content',
  REANALYZED_MESH_MAVEN_CONTENT: 'Reanalyzed Maven content',
  REANALYZED_MESH_MAVEN_RESULTS_FOR_GOALS: 'Regenerated Maven results for goals',
  GENERATED_MESH_MAVEN_PERSONALIZED_GOAL_RESULTS: 'Generated Maven personalized goal results',
};

export const HOME_EVENTS = {
  CLICKED_ON_PRAISE: 'Clicked on Praise',
  CLICKED_ON_ADVISE: 'Clicked on Advise',
  MESH_LIST: {
    VIEWED_TABS: 'Viewed Tabs of HomePage',
    REFRESHED_TABS: 'Refreshed Tabs of HomePage',
    FILTERED_TABS: 'Filtered Tabs of HomePage',
    CREATED_NEW: 'Created New from Tabs of HomePage',
    QUICK_CREATE_INITIATIVE: 'Quickly created Initiative ',
    OPENED_ONE_ON_ONE_SIDEPANEL: 'Opened 1:1 side panel',
    // OPENED_LEVELUP_SIDEPANEL: 'Opened LevelUp side panel',
    // CLICKED_LEVELUP_SIDEPANEL: 'Clicked LevelUp side panel',
    // CHANGED_LEVELUP_PROGRESS: 'Changed LevelUp progress',
    // CHECKED_IN_LEVELUP: 'Checked in LevelUp'
  },
  UPDATE_PROFILE_IMAGE: 'Update profile image',
  CLICKED_VIEW_TEAM_MEMBERS: 'Clicked View Team members',
  CLICKED_VIEW_PROFILE: 'Clicked View Profile',
  UPLOAD_IMAGE: 'Upload image',
  CLICKED_POST: 'Clicked Post',
  POSTED_MESSAGE: 'Posted message',
  LIKED_POST: 'Liked Post',
  SCROLLED_FEED: 'Scrolled feed',
  CLICKED_NUDGE_CARD: 'Clicked Nudge Card',
  TOP_NAV_NAVIGATION_EVENTS: {
    NAVIGATED_TO_HOME: 'Navigated to Home',
    NAVIGATED_TO_GOALS: 'Navigated to Goals',
    NAVIGATED_TO_INITIATIVES: 'Navigated to Initiatives',
    NAVIGATED_TO_ONE_ON_ONES: 'Navigated to 1:1s',
    NAVIGATED_TO_LEVELUP: 'Navigated to LevelUp',
    NAVIGATED_TO_REVIEWS: 'Navigated to Reviews',
    NAVIGATED_TO_ENGAGEMENTS: 'Navigated to Engagements',
    NAVIGATED_TO_ME: 'Navigated to Me',
    NAVIGATED_TO_INSIGHTS: 'Navigated to Insights',
  },
  CLICKED_ON_MY_SUMMARY_FILTERS: 'Clicked on My Summary Filter',
  CLICKED_ON_QUICK_ACTIONS: 'Clicked on quick actions',
  VIEWED_MY_SUMMARY: 'Viewed My Summary',
  VIEWED_MY_FEEDBACK: 'Viewed My Feed',
};

export const GOAL_EVENTS = {
  CREATED_KR: 'Created KR',
  CLICKED_ON_CREATE_KR: 'Clicked on Create KR',
  COMMENTED_ON_KR: 'Commented on KR',
  REALIGNED_KR: 'Realigned KR',
  CLICKED_ON_REALIGNED: 'Re-align button clicked',
  OPENED_KR_PANEL: 'Opened KR panel',
  CREATED_OBJECTIVE: 'Created Objective',
  CLICKED_ON_CREATE_OBJECTIVE: 'Clicked on Create Objective',
  CLICKED_ON_PRAISE: 'Clicked on Praise',

  SORTED_GOALS: 'Sorted Goals',
  CHANGED_VIEW_TYPE: 'Changed View type',
  CLICKED_ON_TIMEPERIOD: 'Clicked on timeperiod',
  APPLIED_FILTER: 'Applied Filter',
  SHARED_KR: 'Shared KR',
  REALIGNED_OBJECTIVE: 'Realigned Objective',
  SHARED_OBJECTIVE: 'Shared Objective',
  OPENED_OBJECTIVE_PANEL: 'Opened Objective Panel',
  UPDATED_OBJECTIVE: 'Updated Objective',
  UPDATED_KR: 'Updated KR',
  DOWNLOAD_CSV: 'Download CSV',

  // RABBIT NEW MIXPANEL EVENTS
  CLICKED_ON_ADD_NEW: 'Clicked on "Add New" button',
  CHECK_IN_KR: 'Checked- in KR',
  ADDED_INITIATIVES_IN_KR: 'Added Initiatives in KR',
  CLICKED_ON_KEBAB_MENU: 'Clicked on Kebab Menu',
  CLICKED_ON_CHECK_IN_BUTTON: 'Check in button clicked',
  CHECK_IN_RECORDED: 'Check in recorded',
  CLICKED_ON_SHOW_PARENT_OBJECTIVE: 'Clicked ParentObj',
  CLICKED_REFRESH: 'Clicked Refresh',
  CLICKED_ON_EXPAND_COLLAPSE: 'Clicked Expand/Collapse',
  GOAL_DELETED: 'Goal Deleted',
  GOAL_UNARCHIVED: 'Goal Unarchived',
  MESH_MAVEN_CLICKED: 'Maven icon clicked',
  AI_SUGGESTION_USED: 'AI suggestion used',
  AI_BUTTON_CLICKED: 'AI button clicked',
  CONFIGURE_MESH_MAVEN_CLICKED: 'Configure Maven clicked',
  CHANGE_DETAILS_CLICKED: 'Change Details clicked',
  DETAILS_SAVED: 'Details saved',
  VIEW_FULL_HISTORY_CLICKED: 'View full history clicked',
  SAVED_GOALS_SETTINGS: 'Saved goals settings',
  CREATED_NEW_GOALS_TEMPLATE: 'Created new goals template',
  GOAL_EDITED: 'Goal edited',
};

export const INITIATIVE_EVENTS = {
  CREATED_INITIATIVE: 'Created Initiative',
  COMMENTED_ON_INITIATIVE: 'Commented on Initiative',
  UPDATED_INITIATIVE: 'Updated Initiative',
  REALIGNED_INITIATIVE: 'Realigned Initiative',
  REALIGNED_PARENT_OF_INITIATIVE: 'Realigned Parent of Initiative',
  OPENED_INITIATIVE_PANEL: 'Opened Initiative Panel',
  SHARED_INITIATIVE: 'Shared Initiative',
  LANDING_PAGE_OF_INITIATIVES: 'Landing Page of Initiatives',
  FILTERS_OF_INITIATIVES: 'Filters of Initiatives',
  CLICKED_ON_TIME_PERIOD_OF_INITIATIVES: 'Clicked on Time Period of Initiatives',
  CHANGED_VIEW_TYPE: 'Changed View Type',
  SORTED_INITIATIVES: 'Sorted Initiatives',
};

export const CONTINUOUS_FEEDBACK_EVENTS = {
  CLICKED_ON_PRAISE: 'Clicked on Praise',
  CLICKED_ON_ADVICE: 'Clicked on Advice',
  SHARED_FEEDBACK: 'Shared Feedback',
  REQUESTED_FEEDBACK: 'Requested Feedback',
  VIEWED_SHARED: 'Viewed Shared',
  RESPONDED_TO_FEEDBACK_REQUEST: 'Responded to Feedback Request',
  RESPONSE_OF_FEEDBACK_REQUEST: 'Response of Feedback Request',
  EDITED_FEEDBACK: 'Edited Feedback',
  VIEWED_FEEDBACK_LIST: 'Viewed Feedback List',
  OPENED_SHARED_FEEDBACK_PANEL: 'Opened Shared Feedback Panel',
  OPENED_REQUEST_FEEDBACK_PANEL: 'Opened Request Feedback Panel',
  OPENED_PENDING_FEEDBACK_PANEL: 'Opened Pending Feedback Panel',
};

export const REVIEW_EVENTS = {
  OPENED_NOMINATION_PANEL: 'Opened Nominations panel',
  SEARCHED_NOMINATION: 'Searched Nominations',

  // CLICKED_NOMINATIONS_BOX: 'Clicked Nominations box',
  SELECTED_NOMINATION: 'Selected Nomination',

  REMOVED_NOMINATION: 'Removed Nomination',

  CLICKED_ADD_MORE: 'Clicked Add More',
  CLOSED_NOMINATIONS_PANEL: 'Closed Nominations panel',
  CLICKED_NOMINATE: 'Clicked Nominate',
  CLICKED_NEXT_PENDING_REVIEWS: 'Clicked next pending reviews',
  CLICKED_PREVIOUS_PENDING_REVIEWS: 'Clicked previous pending reviews',
  OPENED_REVIEW_FORM: 'Opened review form',

  CLICKED_NEXT_REVIEW_FORM: 'Clicked next review form',
  CLICKED_BACK_REVIEW_FORM: 'Clicked back review form',
  ANSWERED_REVIEW_QUESTION: 'Answered review question',
  ACKNOWLEDGED_REVIEW_FORM: 'Acknowledged review form',
  CLICKED_ACCORDION: 'Clicked Accordion ',
  OPENED_REVIEW_GUIDE: 'Opened review guide',

  CHANGED_FORM_SECTION: 'Changed form section',
  CLICKED_REVIEW_CONTEXT: 'Clicked review context',
  OPENED_FEEDBACK_RECEIVED_PANEL: 'Opened feedback received panel',
  CLICKED_NEXT_QUESTION: 'Clicked next question - reviews form filling',
  CLICKED_PREVIOUS_QUESTION: 'Clicked previous question - reviews form filling',
  OPENED_COMPETENCY_PANEL: 'Opened competency panel',
  CLICKED_MANAGE_GOAL_WEIGHTAGE: 'Clicked manage goal weightage - review form',
  CLICKED_VIEW_PAST_REVIEWS: 'Clicked view past reviews - review form',
  CLICKED_REVIEWS_FAQ: 'Clicked reviews faq - review form',
  SUBMITTED_REVIEW_FORM: 'Submitted review form',

  OPEN_COMPETENCY_FROM_ACCORDION: 'Open competency from accordion',
  OPEN_PAST_ONE_ON_ONE_FROM_ACCORDION: 'open past 1:1 from accordion',
  CLICKED_NEXT_ACCORDION: 'Clicked next Accordion',
  CLICKED_PREVIOUS_ACCORDION: 'Clicked previous Accordion',

  CLICKED_NEXT_TEAM_STATUS: 'Clicked next Team status',
  CLICKED_PREVIOUS_TEAM_STATUS: 'Clicked previous Team status',
  CLICKED_NEXT_COMPLETED_REVIEWS: 'Clicked next Completed reviews',
  CLICKED_PREVIOUS_COMPLETED_REVIEWS: 'Clicked previous Completed reviews',
  EMAIL_PDF_REPORT: 'Emailed PDF report',

  // rabbit events ***************************
  MY_REVIEWS_TABLE: 'Navigated to my reviews table',
  REVIEW_CALIBRATION_SIDEPANEL_OPEN: 'Opened Review Panel',
  VIEWED_REVIEW_LIST: 'Viewed Review List',
  SELECTED_REVIEW_CYCLE: 'Selected Review Cycle',
  SELECTED_REVIEW_INSTANCE: 'Selected Review Instance',
  NAVIGATED_TO_REVIEWS: 'Navigated to reviews',

  CLICKED_ON_START_REVIEW: 'Clicked on Start Review',
  CLICKED_ON_CONTINUE_REVIEW: 'Clicked on Continue Review',
  RESPONDED_TO_REVIEW_REQUEST: 'Responded to review request',
  CLICKED_ON_ACKNOWLEDGE: 'Clicked on Acknowledge',
  CLICKED_ON_EDIT_NOMINATION: 'Clicked on Edit Nominations',
  CLICKED_ON_NOMINATE: 'Clicked on Nominate',
  CLICKED_ON_WITHDRAW: 'Clicked on Withdraw',
  CHANGE_WEIGHTAGE: 'Change weightage',
  CLICKED_COMPLETED_BY_ME_VIEW_DETAILS: 'Clicked on View Details',
  CLICKED_PAST_REVIEWS_VIEW_DETAILS: 'Clicked on View Details',
  CHANGED_INSIGHTS_TIMELINE: 'Change insights timeline',
  RECALIBRATE: 'ReCalibrate',
  CLICKED_ON_SAVE_RECALIBRATION: 'Clicked on Save Recalibration',
  CLICKED_ON_CANCEL_RECALIBRATION: 'Clicked on Cancel Recalibration',
  VIEW_FORM: 'View form',
  REOPEN_FORM: 'Reopen form',
  PUBLISH: 'Publish',
  UNPUBLISH: 'Unpublish',
  CLICKED_ON_FORCE_SUBMIT: 'Clicked On Force Submit',
  CLICKED_ON_NOTIFY: 'Notify',
};

export const ONE_ON_ONE_EVENTS = {
  OPENS_ONEONONE_TAB: 'Opens 1:1 tab',
  CREATED_ONEONONE: 'Created 1:1',
  OPENED_ONEONONE_DETAIL: 'Opened 1:1 Detail',
  CLICKED_CALENDAR_NOTIFICATION: 'Clicked calendar notification',
  OPENED_ONEONONE_PREFERENCE: 'Opened 1:1 preference',
  CLICKED_ON_MOOD_QUESTION: 'Clicked on mood question',
  RESPONDED_TO_MOOD_QUESTION: 'Responded to mood question',
  ADDED_TO_ONEONONE_AGENDA: 'Added to 1:1 agenda',
  COMPLETED_ONEONONE_AGENDA: 'Completed 1:1 agenda',
  ADDED_COMMENTS_TO_ONEONONE_QUESTIONS: 'Added comments to 1:1 questions',
  ADDED_ACTION_ITEMS_TO_ONEONONE: 'Added action items to 1:1',
  COMPLETED_ACTION_ITEMS: 'Completed action items',
  ADDED_ACTION_ITEM_OWNER: 'Added action item owner',
  ADDED_ACTION_ITEM_DATE: 'Added action item date',
  RESCHEDULED_ONEONONE: 'Rescheduled 1:1',
  COMPLETED_ONEONONE: 'Completed 1:1',
  ARCHIVED_ONEONONE: 'Archived 1:1',
  UNARCHIVED_ONEONONE: 'Unarchived 1:1',
  CLICKED_ON_MESH_RECOMMENDS: 'Clicked on mesh recommends',
  STARTS_ONE_ON_ONE: 'Starts 1:1',
  CONTINUES_ONEONONE: 'Continues 1:1',
  VIEWS_ONEONONE: 'Views 1:1',
  CLICKED_ON_END_MEETING: 'Clicked on End Meeting',
  CLICKED_ON_REOPEN: 'Clicked on Reopen',
  CLICKED_ON_RESCHEDULE: 'Clicked on Reschedule',
  CLICKED_ON_CANCEL: 'Clicked on Cancel',
  CLICKED_ON__ONE_ON_ONE_FILTER: 'Clicked on 1:1 Filter', // Done
  CLICKED_ON_MY_ONE_ON_ONE_KEBAB_BUTTON: 'Clicked on My 1:1 Kebab Button',
  CLICKED_ON_CREATE_NEW_ONE_ON_ONE: 'Clicked on Add New 1:1',
  ADDED_NEW_ONE_ON_ONE: 'Added New 1:1',
  OPENED_ONE_ON_ONE_INSTANCE_PAGE: 'Opened 1:1 instance',

  // instance page
  CLICKED_ON_MODULE_DATA: 'Clicked on module data in 1:1s',
  CLICKED_ON_ADD_CUSTOM_AGENDA: 'Added 1:1 agenda',
  ADD_ONE_ON_ONE_ADMIN_AGENDA_POINTS: 'Added 1:1 Admin Agenda Points',
  CLICKED_ON_ADD_INITIATIVE: 'Clicked on add 1:1 initiative',
  AGENDA_ITEMS_REORDERED: 'Agenda items reordered',
  ADDED_AGENDA_ITEM_NOTES: 'Added agenda item notes',
  CLICKED_ON_DELETE_AGENDA: 'Clicked on delete agenda',
  COMPLETED_AGENDA: 'Completed agenda',
  COMPLETED_ONE_ON_ONE_INITIATIVE: 'Completed 1:1 initiative',
  ADDED_ONE_ON_ONE_NOTES: 'Added 1:1 notes',
  CLICKED_ON_EDIT_ONE_ON_ONE: 'Edited 1:1 ',
  CANCELLED_ONE_ON_ONE_INSTANCE: 'Cancelled 1:1 instance',
  ARCHIVED_ONE_ON_ONE_INSTANCE: 'Archived 1:1 instance',

  // Add from library
  ADDED_ONE_ON_ONE_AGENDA: 'Added 1:1 agenda',
  PROVIDED_SATISFACTION_SCORE: 'Provided satisfaction score',
  SAVED_ONE_ON_ONE_SETTINGS: 'Saved 1:1 settings',
  SYNC_ONE_ON_ONE_CALENDAR_EVENT: 'Sync calendar',
};

export const LEVELUP_EVENTS = {
  ADDED_ONBOARDING_TO_ONE_ON_ONE: 'Added onboarding to 1:1',

  SETUP_LEVELUP_ROLE: 'Setup Develop role',
  ADDED_TARGET_QUARTER: 'Added target quarter',
  CHANGED_TARGET_QUARTER: 'Changed target quarter',
  CLICKED_ON_MESH_RECOMMENDS: 'Clicked on mesh recommends',
  OPENED_LEVELUP_SIDEPANEL: 'Opened Develop side panel',
  CLICKED_LEVELUP_SIDEPANEL: 'Clicked Develop side panel',
  ADDED_TO_ONE_ON_ONE_AGENDA: 'Added to 1:1 agenda',
  CHANGED_LEVELUP_PROGRESS: 'Changed Develop progress',
  CHECKED_IN_LEVELUP: 'Checked in Develop',

  CLICKED_TOP_VIEW_FILTER: 'Clicked top view filter',

  ADDED_LEVELUP_COMMENT: 'Added Develop comment',
  RESPONDED_TO_CHECK_IN: 'Responded to check-in',
  ADDED_ACTION_ITEM: 'Added action item/initiatives',
  COMPLETED_ACTION_ITEM: 'Completed action item/initiatives',
  CLICKED_ON_LEVELUP_TAB: 'Clicked on Develop tab',
  LEVEL_UP_VIEW_CHANGE: 'Develop View Change',
  LEVEL_UP_EXPANDED_VIEW: "Expanded Report's View",
  LEVEL_UP_CLICKED_ON_DISCUSS_NEXT_ONE_ON_ONE: 'Clicked on discuss in next 1:1',
};
export const ENGAGEMENT_EVENTS = {
  SHARE_EXPERIENCE_CLICKED: 'Share experience clicked',
  SHARE_EXPERIENCE_PUBLISHED: 'Share experience published',
  OPENED_ENGAGEMENT_SURVEY: 'Opened engagement survey',
  ANSWERED_SURVEY_QUESTION: 'Answered survey question',
  CLICKED_NEXT_ENGAGEMENT_SURVEY: 'Clicked next engagement survey',
  CLICKED_BACK_ENGAGEMENT_SURVEY: 'Clicked back engagement survey',
  SUBMITTED_SURVEY_FORM: 'Submitted survey form',
  CLICKED_ON_ENGAGEMENT_FILTER: 'Clicked on Engagement Filter',
  STARTED_ENGAGEMENT_SURVEY: 'Started engagement survey',
  VIEWED_SUBMITTED_SURVEY: 'Viewed Submitted Survey',
  SELECTED_SURVEY: 'Selected Survey',
  SCROLLED_DRIVER_BADGES: 'Scrolled Driver Badges',
};
export const INSIGHT_EVENTS = {
  CLICKED_MAX_PROGRESS_OF_GOALS: 'Clicked Maximum Progress of Goals',
  CLICKED_MIN_PROGRESS_OF_GOALS: 'Clicked Minimum Progress of Goals',
  CLICKED_INSIGHTS_GRAPH_OF_GOALS: 'Clicked on Insights Graph of Goals',

  CLICKED_MAX_GROWTH_OF_CF: 'Clicked Maximum Growth of CF',
  CLICKED_MIN_GROWTH_OF_CF: 'Clicked Minimum Growth of CF',
  CLICKED_INSIGHTS_GRAPH_OF_CF: 'Clicked on Insights Graph of CF',

  SELECTED_COHORT: 'Selected cohort',
  CREATE_NEW_COHORT: 'Create new cohort',
  APPLY_NEW_COHORT: 'Apply new cohort',
  SELECTED_GROUP_BY: 'Selected group by',
  DOWNLOAD_CSV: 'Download CSV',
  CHANGED_TIMELINE: 'Changed timeline',
  CHANGED_REVIEW_CYCLE: 'Changed review cycle',

  OPENED_STATUS_INSIGHTS: 'Opened Status insights',
  OPENED_CALIBRATION_INSIGHTS: 'Opened Calibration insights',
  CALIBRATED_SCORE: 'Calibrated score',
  COMPLETED_CALIBRATION: 'Completed calibration',

  CHANGED_SURVEY: 'Changed survey',
  CHANGED_SPLIT_BY: 'Changed split by',
  DRIVER_CLICKED: 'Driver clicked',
  EXPANDED_CHART: 'Expanded chart',
  SORTED_COLUMNS: 'Sorted Columns',

  AG_GRID_FILTER: 'Ag Grid Filter',
  AG_GRID_SORT: 'Ag Grid Sort',
  CLICKED_ON_CHANGE_COLUMNS: 'Clicked on Change Columns',
};

export const SETTINGS_EVENTS = {
  MY_PODS_CREATE_A_POD: 'Create a Pod',
  ORG_DETAILS_UPDATED_ORGANISATION_DETAILS: 'Updated Organisation Details',
  EMPLOYEE_DETAILS_ADDED_EMPLOYEE: 'Added Employee',
  EMPLOYEE_DETAILS_BULK_UPLOAD: 'Bulk Upload',
  EMPLOYEE_DETAILS_DELETED_AN_EMPLOYEE: 'Deleted an Employee',
  EMPLOYEE_DETAILS_OPENED_EMPLOYEE_DETAILS: 'Opened Employee Details',
  EMPLOYEE_DETAILS_UPDATED_EMPLOYEE_DETAILS: 'Updated Employee Details',
  EMPLOYEE_DETAILS_DOWNLOAD_CSV: 'Download CSV',
  EMPLOYEE_DETAILS_SEARCHED_EMPLOYEE: 'Searched Employee',
  COMPETENCIES_ADDED_COMPETENCY: 'Added Competency',
  COMPETENCIES_CHANGED_SETTING: 'Changed Setting',
  COMPETENCIES_UPDATED_DESCRIPTION: 'Updated Description',
  FUNCTION_AND_GRADE_CLICKED_ON_FUNCTION: 'Clicked on Function',
  ACCESS_CONTROL_CLICKED_ON_CREATE_ACCESS: 'Clicked on Create Access',
  ACCESS_CONTROL_EDIT_EMPLOYEES: 'Edit Employees',
  ACCESS_CONTROL_SAVED_CUSTOM_ACCESS: 'Saved Custom Access',
  MODULE_PREFERENCES_CHANGED_MODULE_PREFERENCES: 'Changed Module Preferences',
  NOTIFICATIONS_CHANGED_NOTIFICATION_PREFERENCES: 'Changed Notification Preferences',
  NOTIFICATIONS_SET_DEFAULT_PREFERENCES: 'Set Default Preferences',
  NOTIFICATIONS_RESET_DEFAULT_PREFERENCES: 'Reset Default Preferences',
  OBJECTIVES_CLONED_OBJECTIVE: 'Cloned Objective',
  OBJECTIVES_RENAMED_OBJECTIVE: 'Renamed Objective',
  OBJECTIVES_REPLACE_OBJECTIVE: 'Replace Objective',
  OBJECTIVES_DELETED_OBJECTIVE: 'Deleted Objective',
  OBJECTIVES_CLICKED_ALL_OBJECTIVES_IN_SETTINGS: 'Clicked All Objectives in Settings',
  OBJECTIVES_CLICKED_ACTIVE_OBJECTIVES_IN_SETTINGS: 'Clicked Active Objectives in Settings',
  OBJECTIVES_UPDATED_FREQUENCY_OF_GOALS: 'Updated Frequency of Goals',
  OBJECTIVES_UPDATED_START_MONTH_OF_GOALS: 'Updated Start Month of Goals',
  OBJECTIVES_UPDATED_DEFAULT_VISIBILITY_OF_GOALS: 'Updated Default Visibility of Goals',
  ONEONONE_QUESTION_LIBRARY_ADDED_QUESTION: 'Added question',
  ONEONONE_QUESTION_LIBRARY_DUPLICATED_QUESTION: 'Duplicated question',
  ONEONONE_QUESTION_LIBRARY_ARCHIVED_QUESTION: 'Archived question',
  ONEONONE_QUESTION_LIBRARY_COPIED_QUESTION_LINK: 'Copied question link',
  ONEONONE_TEMPLATES_ADDED_TEMPLATE: 'Added template',
  ONEONONE_TEMPLATES_DUPLICATED_TEMPLATE: 'Duplicated template',
  ONEONONE_TEMPLATES_ARCHIVED_TEMPLATE: 'Archived template',
  ONEONONE_SETTINGS_MODIFIED_FREQUENCY: 'Modified frequency',
  ONEONONE_SETTINGS_MODIFIED_TEMPLATE: 'Modified template',
  REVIEWS_QUESTION_LIBRARY_ADDED_QUESTION: 'Added question',
  REVIEWS_QUESTION_LIBRARY_DUPLICATED_QUESTION: 'Duplicated question',
  REVIEWS_QUESTION_LIBRARY_ARCHIVED_QUESTION: 'Archived question',
  REVIEWS_QUESTION_LIBRARY_COPIED_QUESTION_LINK: 'Copied question link',
  REVIEWS_QUESTION_LIBRARY_SEARCHED_A_QUESTION: 'Searched a question',
  REVIEWS_QUESTION_LIBRARY_CLICKED_ON_SAMPLE_QUESTIONS: 'Clicked on sample question',
  REVIEWS_QUESTION_LIBRARY_CLICKED_ON_ARCHIVED_QUESTIONS: 'Clicked on archived question',
  REVIEWS_QUESTION_LIBRARY_SAVED_QUESTION: 'Saved question',
  REVIEWS_TEMPLATE_CLICKED_ON_ADD_TEMPLATE: 'Clicked on add template',
  REVIEWS_TEMPLATE_CREATED_A_NEW_TEMPLATE: 'Created a new template',
  REVIEWS_TEMPLATE_DUPLICATED_TEMPLATE: 'Duplicate template',
  REVIEWS_TEMPLATE_ARCHIVED_TEMPLATE: 'Archived template',
  REVIEWS_TEMPLATE_OPENED_TEMPLATE: 'Opened template',
  REVIEWS_TEMPLATE_CLICKED_MODIFY_TEMPLATE: 'Clicked modify template',
  REVIEWS_TEMPLATE_CLICKED_PREVIEW: 'Clicked preview',
  REVIEWS_TEMPLATE_SAVED_A_TEMPLATE: 'Saved a template',
  REVIEWS_CYCLE_CLICKED_ON_CREATE_NEW: 'Clicked on create new',
  REVIEWS_CYCLE_OPENED_REVIEW_SETTINGS: 'Opened review settings',
  REVIEWS_CYCLE_CLICKED_ON_NEXT_REVIEW_CYCLE_SETTINGS: 'Clicked on next review cycle settings',
  REVIEWS_CYCLE_CLICKED_ON_BACK_REVIEW_CYCLE_SETTINGS: 'Clicked on back review cycle settings',
  REVIEWS_CYCLE_CREATED_A_REVIEW_CYCLE_INSTANCE: 'Created a review cycle instance',
  CALIBRATION_SETTINGS_CHANGED_REVIEW_CYCLE_DATE: 'Changed review cycle date',
  CALIBRATION_SETTINGS_CHANGED_SCORE_TYPE: 'Changed score type',
  CALIBRATION_SETTINGS_SAVED_CALIBRATION_GRID_CHANGES: 'Saved calibration grid changes',
  ENGAGEMENT_DRIVERS_ADDED_NEW_DRIVER: 'Added new driver',
  ENGAGEMENT_DRIVERS_UPDATED_ENGAGEMENT_DRIVER: 'Updated engagement driver',
  ENGAGEMENT_DRIVERS_DELETED_ENGAGEMENT_DRIVER: 'Deleted engagement driver',
  ENGAGEMENT_QUESTIONS_ADDED_QUESTION: 'Added question',
  ENGAGEMENT_QUESTIONS_DUPLICATED_QUESTION: 'Duplicated question',
  ENGAGEMENT_QUESTIONS_ARCHIVED_QUESTION: 'Archived question',
  ENGAGEMENT_QUESTIONS_COPIED_QUESTION_LINK: 'Copied question link',
  ENGAGEMENT_QUESTIONS_SEARCHED_A_QUESTION: 'Searched a question',
  ENGAGEMENT_QUESTIONS_CLICKED_ON_SAMPLE_QUESTIONS: 'Clicked on sample questions',
  ENGAGEMENT_QUESTIONS_CLICKED_ON_ARCHIVED_QUESTIONS: 'Clicked on archived questions',
  ENGAGEMENT_QUESTIONS_SAVED_QUESTION: 'Saved question',
  ENGAGEMENT_TEMPLATE_CLICKED_ON_ADD_TEMPLATE: 'Clicked on add templated',
  ENGAGEMENT_TEMPLATE_CREATED_A_NEW_TEMPLATE: 'Created a new template',
  ENGAGEMENT_TEMPLATE_DUPLICATED_TEMPLATE: 'Duplicated template',
  ENGAGEMENT_TEMPLATE_ARCHIVED_TEMPLATE: 'Archived template',
  ENGAGEMENT_TEMPLATE_OPENED_TEMPLATE: 'Opened template',
  ENGAGEMENT_TEMPLATE_CLICKED_MODIFY_TEMPLATE: 'Clicked modify template',
  ENGAGEMENT_TEMPLATE_CLICKED_PREVIEW: 'Clicked preview',
  ENGAGEMENT_TEMPLATE_SAVED_A_TEMPLATE: 'Saved a template',
  ENGAGEMENT_SURVEYS_CLICKED_ON_CREATE_NEW: 'Clicked on create new',
  ENGAGEMENT_SURVEYS_OPENED_SURVEY_SETTINGS: 'Opened survey settings',
  ENGAGEMENT_SURVEYS_CLICKED_ON_NEXT_SURVEY_SETTINGS: 'Clicked on next survey settings',
  ENGAGEMENT_SURVEYS_CLICKED_ON_BACK_SURVEY_SETTINGS: 'Clicked on back survey settings',
  ENGAGEMENT_SURVEYS_CLICKED_ON_CREATE_SURVEY: 'Clicked on created survey',
  INITIATIVE_TAGS_ADDED_NEW_TASK_TAG: 'Added new task tag',
  SLACK_CLICKED_ON_ADD: 'Slack clicked on add',
  SLACK_INTEGRATION_SUCCESSFUL: 'Slack integration successful',
  HELP_OPENED_KNOWLEDGE_HUB: 'Opened knowledge hub',
  HELP_REPORT_A_BUG: 'Report a bug',
};

export const MESH_RECOMMENDATIONS_EVENTS = {
  CLICKED_ON_MESH_RECOMMENDS: 'Clicked on Mesh Recommends',
  SNOOZED_MESH_RECOMMENDS: 'Snoozed Mesh Recommends',
};

export const VIEWS_EVENTS = {
  CREATE_VIEW: 'Create View',
  OPEN_MANAGE_VIEWS: 'Open Manage Views',
  APPLY_VIEW: 'Apply View',
  VIEWS_FILTER_BUTTON_CLICKED: 'Views Filter Button Clicked',
  VIEWS_MENU_CLONE_CLICKED: 'Views Menu Clone Clicked',
  VIEWS_MENU_EDIT_CLICKED: 'Views Menu Edit Clicked',
  VIEWS_MENU_DELETE_CLICKED: 'Views Menu Delete Clicked',
  APPLY_AND_SAVE_VIEW: 'Apply And Save View',
  SEARCH_VALUES: 'Search Values',
  UPLOAD_CSV_IN_NAMES: 'Upload CSV in Names',
};

export const ONE_ON_ONE_RABBIT_LANDING_PAGE = {
  CLICKED_ON__ONE_ON_ONE_FILTER: 'Clicked on 1:1 Filter',
  ARCHIVED_ONE_ON_ONE: 'Clicked on Archive 1:1',
  CLICKED_ON_MY_ONE_ON_ONE_KEBAB_BUTTON: 'Clicked on My 1:1 Kebab Button',
  CLICKED_ON_ADD_NEW_ONE_ON_ONE: 'Clicked on Add New 1:1',
  ADDED_NEW_ONE_ON_ONE: 'Added New 1:1',
};

export const ONE_ON_ONE_RABBIT_SETTINGS_PAGE = {
  CLICKED_ON_ONE_ON_ONE_SCORE_SETTINGS: 'Clicked on 1:1 Score Settings',
  ADDED_ADMIN_AGENDA_POINTS: 'Added Admin Agenda Points',
  CREATED_ONE_ON_ONE_LIFECYCLE_EVENT: 'Created 1:1 Lifecycle Event',
  CLICKED_ON_CALENDER_INTEGRATION: 'Clicked on calendar Integration',
};

export const PARTIAL_PUBLISH_EVENTS = {
  SELECT_ALL_EMPLOYEES: 'Select all employees Reviews',
  SELECT_CURRENT_PAGE_EMPLOYEES: 'Select all on page Reviews',
  CHECKBOX_SELECTION: 'Checkbox Reviews',
  CLEAR_SELECTION: 'Clear selection Reviews',
  SHARE_RESULTS_BUTTON: 'Share results Reviews',
  NO_ACTION_EXPANSION: 'No action expansion Reviews',
  SEARCH_IN_NO_ACTION: 'Search in no action Reviews',
  SHARE_RESULTS_K_BASE: 'Share results kBase Reviews',
  SWITCH_PUBLISH_OPTIONS: 'Share radio Reviews',
  CANCEL_FIRST_SCREEN: 'Cancel Reviews',
  NEXT_FIRST_SCREEN: 'Next Reviews',
  CONFIRMATION_CHECKBOX: 'Confirmation checkbox Reviews',
  CONFIRMATION_CANCEL: 'Confirmation cancel Reviews',
};

export const BULK_NOTIFY_EVENTS = {
  BULK_NOTIFY_BUTTON: 'Opened Bulk Notify Panel',
  BULK_NOTIFY_REVIEWER_TYPE_CHECKBOX: 'Clicked BN checkbox',
  BULK_NOTIFY_CLOSE_REVIEWS: 'Closed BN Panel',
  BULK_NOTIFY_REVIEWS: 'Notify',
};

export const CF_GEN_AI_EVENTS = {
  AI_BUTTON_CLICKED: 'AI button clicked',
  AI_SUGGESTION_USED: 'AI suggestion used',
};

export const VISIER_ANALYTICS_EVENTS = {
  NAVIGATED_TO_REPORTS: 'Navigated to reports',
  NAVIGATED_TO_GOALS_REPORTS: 'Navigated to goals reports',
  NAVIGATED_TO_REVIEW_REPORTS: 'Navigated to review reports',
  NAVIGATED_TO_ONE_ON_ONE_REPORTS: 'Navigated to oneOnOne reports',
  NAVIGATED_TO_GOALS_INSIGHTS: 'Navigated to goals insights',
  NAVIGATED_TO_COMPETENCIES_INSIGHTS: 'Navigated to competencies insights',
  NAVIGATED_TO_ONE_ON_ONE_INSIGHTS: 'Navigated to oneOnOne insights',
  NAVIGATED_TO_REVIEWS_INSIGHTS: 'Navigated to reviews insights',
  NAVIGATED_TO_ENGAGEMENT_INSIGHTS: 'Navigated to engagement insights',
};

export const NEW_NAV_EVENTS = {
  CLICKED_NEW_NAV_BANNER: 'Clicked on new nav banner',
  PAGE_VIEW: 'Page View',
  CLICKED_PREVIEW: 'Clicked on preview for me',
  CLICKED_LAUNCH_FOR_ALL: 'Clicked on launch for all',
  LAUNCHED_NEW_NAV_FOR_ORG: 'Launched new nav for org',
  CLICKED_ON_BACK_TO_RABBIT: 'Clicked on back to rabbit',
  CLICKED_ON_SEARCH: 'Clicked on Search',
  CLICKED_ON_HOME: 'Clicked on Home',
  CLICKED_ON_ME: 'Clicked on Me',
  HOVERED_ON_TEAMS: 'Hovered on Teams',
  CLICKED_ON_DIRECT_TEAM: 'Clicked on Direct Team',
  CLICKED_ON_SKIP_TEAM: 'Clicked on Skip Team',
  CLICKED_ON_COMPANY: 'Clicked on Company',
  CLICKED_ON_ASK_MAVEN: 'Clicked on Ask Maven',
  HOVERED_ON_QUICK_ADD: 'Hovered on Quick Add',
  HOVERED_ON_PROFILE_ICON: 'Hovered on Profile Icon',
  SAVE_BULK_CHECKIN_GOALS: 'Save Bulk Checkin Goals',
  CANCEL_BULK_CHECKIN_GOALS: 'Cancel Bulk Checkin Goals',
  CHANGED_STATUS_BULK_CHECKIN_GOALS: 'Change Status Bulk Checkin Goals',
  CHANGED_ACHIEVED_VALUE_BULK_CHECKIN_GOALS: 'Change Achieved Value Bulk Checkin Goals',
  ADDED_COMMENT_BULK_CHECKIN_GOALS: 'Added Comment Bulk Checkin Goals',
  BULK_UPLOAD_TIMELINE_CHANGE: 'Clicked on time period',
  BULK_UPLOAD_ATTACHED_FILE: 'Attached File',
  BULK_UPLOAD_UPLOADED_FILE: 'Uploaded File',
  BULK_UPLOAD_DOWNLOAD_GOAL_QUICK_SAMPLE: 'Download Goal Quick Sample',
  BULK_UPLOAD_DOWNLOAD_GOAL_EXTENDED_SAMPLE: 'Download Goal Extended Sample',
  BULK_UPLOAD_VIEW_GUIDE: 'View Goal Upload Guide',
  CLICKED_ON_COLD_START_NUDGE: 'Clicked on cold start nudge',
  CREATED_A_CUSTOM_TEAM: 'Created a custom team',
};

export const ALL_TRACKING_EVENTS = {
  ...GENERIC_EVENTS,

  ...HOME_EVENTS,
  ...HOME_EVENTS.MESH_LIST,
  ...HOME_EVENTS.TOP_NAV_NAVIGATION_EVENTS,

  ...GOAL_EVENTS,
  ...INITIATIVE_EVENTS,
  ...CONTINUOUS_FEEDBACK_EVENTS,
  ...REVIEW_EVENTS,
  ...ONE_ON_ONE_EVENTS,
  ...LEVELUP_EVENTS,
  ...ENGAGEMENT_EVENTS,
  ...INSIGHT_EVENTS,
  ...SETTINGS_EVENTS,
  ...GENERIC_EVENTS,
  ...MESH_RECOMMENDATIONS_EVENTS,
  ...VIEWS_EVENTS,
  ...ONE_ON_ONE_RABBIT_SETTINGS_PAGE,
  ...PARTIAL_PUBLISH_EVENTS,
  ...CF_GEN_AI_EVENTS,
  ...BULK_NOTIFY_EVENTS,
  ...VISIER_ANALYTICS_EVENTS,
  ...NEW_NAV_EVENTS,
};

// Sources enums for different modules' events -------------------------------------------

export const EVENT_SOURCES = {
  HOME: 'Home Page',
  PROFILE_PAGE: 'Profile Page',
  ONE_ON_ONE: '1:1',
  LEVEL_UP: 'LevelUp',
  MESH_LIST: 'Mesh List',

  MY_GOALS_OVERALL: 'My Goals Overall',
  MY_GOALS_LIST: 'My Goals List',

  TEAM_PAGE_OVERALL: 'Team Page Overall',
  TEAM_PAGE_LIST: 'Team Page List',

  INSIGHTS_PAGE_OVERALL: 'Insights Page Overall',
  INSIGHTS_PAGE_LIST: 'Insights Page List',

  MY_INITIATIVES: 'My Initiatives',
  INITIATIVE_PODS: 'Initiative Pods',

  COMPETENCY_PANEL: 'Competency Panel',
  REVIEWS_PAGE: 'Reviews Page',

  FEEDBACK_PAGE: {
    MY_FEEDBACK: 'MY FEEDBACK',
    PENDING_MY_FEEDBACK: 'PENDING MY FEEDBACK',
  },
};

export const REVIEWS_EVENT_SOURCES = {
  COMPETENCY_PANEL: 'Competency Panel',
  REVIEWS_PAGE: 'Reviews Page',
  HOME: 'Home Page',
  PROFILE_PAGE: 'Profile Page',
  REVIEWS: 'Reviews',
  PENDING_REVIEWS: 'Pending Reviews',
  TEAM_STATUS: 'Team Status',
  SEARCH: 'Search',
  RECOMMENDED_PEERS: 'Recommended Peers',
  COMPLETED_REVIEW: 'Completed Review',
  INSIGHTS: 'Insights',
  MESH_LIST: 'Mesh List',

  MY_GOALS_OVERALL: 'My Goals Overall',
  MY_GOALS_LIST: 'My Goals List',
  TEAM_PAGE_OVERALL: 'Team Page Overall',
  TEAM_PAGE_LIST: 'Team Page List',
  INSIGHTS_PAGE_OVERALL: 'Insights Page Overall',
  INSIGHTS_PAGE_LIST: 'Insights Page List',
};

export const ONE_ON_ONE_EVENT_SOURCES = {
  LANDING_PAGE: 'Landing Page',
  LIST_PAGE: 'List Page',
  PREV_ONE_ON_ONE_LIST: 'Prev 1:1 List',
  PREV_ONE_ON_ONE_BUTTON: 'Prev 1:1 Button',
  HOME: 'Home Page',
  LEVEL_UP_MODULE: 'Level Up Module',
  ONE_ON_ONE: '1:1',
  COMPETENCY_PANEL: 'Competency panel',
  REVIEWS_PAGE: 'Reviews Page',
};

export const LEVEL_UP_EVENT_SOURCES = {
  ONE_ON_ONE: '1:1',
  LEVEL_UP_TAB: 'LevelUp Tab',
  LEVEL_UP_MODULE: 'LeverUp Module',
  COMPETENCY_PANEL: 'Competency Panel',
  REVIEWS_PAGE: 'Reviews Page',
  HOME: 'Home Page',
  PROFILE_PAGE: 'Profile Page',
};

export const SETTINGS_EVENT_SOURCES = {
  SETTINGS: 'Settings',
  PANEL: 'Panel',
  REVIEWS: 'Reviews',
  ENGAGEMENT: 'Engagement',
  ONE_ON_ONE: '1:1',
};

export const INSIGHTS_EVENT_SOURCES = {
  GOALS: 'Settings',
  ONE_ON_ONE: '1:1',
  REVIEWS: 'Reviews',
  FEEDBACKS: 'Feedbacks',
  ENGAGEMENT: 'Engagement',
};

export const GOALS_EVENT_SOURCES = {
  ADD_GOAL_PANEL: 'Add Goal panel',
  EDIT_GOAL_PANEL: 'Edit goal panel',
  GOALS_KEBAB_MENU: 'Goal Kebab Menu',
  GOAL_TITLE: 'Goal Title',
  AI: {
    type: {
      HELP_ME_WRITE: 'Help me write',
      REPHRASE: 'Rephrase',
      REANALYZE: 'Reanalyze',
      TRY_AGAIN: 'Try Again',
      GENERATE_AFTER_CONFIGURATION: 'Generate after configuration',
    },
    purpose: {
      CF: 'CF',
      Reviews: 'Reviews',
      Goal_Creation: 'Goal_Creation',
      Goal_Editing: 'Goal_Editing',
    },
  },
  CONFIGURE_AI: {
    type: {
      Parameters_Change: 'Parameters_Change',
      Title_Change: 'Title_Change',
    },
  },
};
